import { Navigate } from "react-router-dom"
import { useAuthUser } from "../hooks/useAuth"
import { isFullScope, isTwoFaScope } from "../constants"
import routePaths from "../constants/path"
import { getLandingPath } from "../routes"

const PublicRoute = ({ component }) => {
  const { data, isLoading, isError } = useAuthUser()

  // Render the public page immediately instead of blocking on a full-page
  // loader; the auth check runs in the background and only redirects once
  // it confirms there's already a logged-in session.
  if (isLoading || isError || !data) return <>{component}</>

  if (isFullScope(data.scope)) {
    return <Navigate replace to={getLandingPath(data.data?.role)} />
  }

  if (isTwoFaScope(data.scope)) {
    return data.twoFAEnabled ? (
      <Navigate replace to={routePaths.verifyTwoFa} />
    ) : (
      <Navigate replace to={routePaths.enableTwoFa} />
    )
  }

  return <>{component}</>
}

export default PublicRoute
